// extracted by mini-css-extract-plugin
export default {"tabs":"SearchResult_tabs__pi9gF"};